module.exports = __webpack_public_path__ + "static/media/DSCF0008.710c45ab.jpg";